enum LanguageEnum {
    es_ES = 1,
    es_EC = 2
}

export default LanguageEnum